var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-img", {
        staticClass: "mmp-img",
        attrs: {
          fluid: "",
          alt: "Responsive image",
          src: "../../../assets/MapManagementPlatform.png",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info-tooltip" },
        [
          _c("fa", {
            staticClass: "info-icon",
            attrs: { icon: ["fas", "info-circle"] },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "info-tooltip-text" }, [
            _vm._v("\n      DMP Map Management Platform\n      "),
            _c("br"),
            _vm._v(
              "\n      Version " +
                _vm._s(this.versionReleaseInfo.version) +
                "\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      Released " +
                _vm._s(this.versionReleaseInfo.release_date) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }